import { Dispatch, SetStateAction, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { uploadCompaniesCsvRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';
import { CompanyData } from '../types';

type useUploadCompaniesCsvProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUploadCompaniesCsv = ({
    setErrorText = () => { },
}: useUploadCompaniesCsvProps) => {
    const client = useQueryClient();
    const [companiesData, setCompaniesData] = useState([] as CompanyData[]);

    const { mutate: uploadCompaiesCsv, isLoading: isUploadCompaiesCsv } =
        useMutation({
            mutationFn: (variables: {
                template_id: string | number
                file: File
            }) =>
                axiosInstance
                    .post(uploadCompaniesCsvRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else if (data.status === 200 && data.objects?.length > 0) {
                    const uniqueEmails = new Set();
                    const filteredCompanies = data.objects
                        .filter((item: any) => {
                            if (!uniqueEmails.has(item.email)) {
                                uniqueEmails.add(item.email);
                                return true;
                            }
                            return false;
                        })
                        .map((item: any) => ({
                            ...item,
                            email: item.email,
                            user_name: item.full_name,
                        }));

                    setCompaniesData(filteredCompanies);
                    setErrorText('');
                    client.invalidateQueries([templateList]);
                }
            },
            onError: () => {
                setErrorText(errorMessage)
                return
            },
        });

    return {
        uploadCompaiesCsv,
        isUploadCompaiesCsv,
        data: companiesData,
    };
};
